module.exports = __webpack_public_path__ + "static/media/weatherDashPic.6220f9f0.jpg";